export const EXTERNAL_SOURCES = {
  CKLA_HUB: 'ckla-hub',
  READING: 'reading',
  ELA: 'ela',
};
